export default "__VITE_ASSET__$tOs7EA2__"